export default __webpack_public_path__ + "static/wide_logo-57c177a0c602b5b920788470f638fffe.svg";